import axios from 'axios'
import config from '../../config.json'

axios.defaults.baseURL = config.baseUrl
axios.defaults.timeout = 5000
axios.defaults.headers.common['Content-Type'] = 'application/json'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 可以在这里添加请求头或者token
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const res = response.data
    // 根据返回的状态码处理不同的响应
    if (response.status === 200) {
      return response
    } else {
      console.log('响应拦截器错误1', res)
      return Promise.reject(new Error(res.msg || 'Error'))
    }
  },
  error => {
    console.log('响应拦截器错误2', error)
    return Promise.reject(error)
  }
)

// 封装请求方法
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function put(url, data) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function del(url, data) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function postWithHeaders(url, data, headers) {
  return new Promise((resolve, reject) => {
    axios.post(url, data, { headers }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export default {
  get,
  post,
  put,
  del,
  postWithHeaders
}
